import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  output,
  viewChild,
} from '@angular/core';
import { IconsNgModule } from '@seech/icons-ng';
import {
  LayoutMobileStatusCommand,
  LayoutMobileStatusViewModel,
} from './layout-presentation.models';

@Component({
  selector: 'app-layout-mobile-status',
  standalone: true,
  imports: [IconsNgModule],
  templateUrl: './layout-mobile-status.component.html',
  styleUrl: './layout-mobile-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutMobileStatusComponent {
  readonly model = input.required<LayoutMobileStatusViewModel>();
  readonly navigationOpen = input(false);
  readonly commandRequested = output<LayoutMobileStatusCommand>();

  private readonly navigationButton =
    viewChild<ElementRef<HTMLButtonElement>>('navigationButton');

  focusNavigationButton(): void {
    this.navigationButton()?.nativeElement.focus();
  }
}
